import { API } from "../../../../common/api/constants";

// ПОЛУЧИТЬ СПИСОК ПЕРСОН ПО НОМЕРУ ЗАКАЗА
export const GET_ORDER_PERSONS = `${API}/order/orders/{order_id}/persons`; // GET

// ДОБАВИТЬ ПЕРСОНУ В СПИСОК ПО НОМЕРУ ЗАКАЗА
export const ADD_PERSON_TO_LIST = `${API}/order/orders/{order_id}/persons`; // POST

// УДАЛИТЬ ПЕРСОНУ ИЗ СПИСКА
export const DELETE_PERSON = `${API}/order/orders/{order_id}/persons/{person_id}`; // DELETE

// УДАЛИТЬ ПЕРСОНУ ИЗ СПИСКА
export const EDIT_PERSON = `${API}/order/orders/{order_id}/persons/{person_id}`; // PUT
